<template>
    <div class="home" ref="home">
        <div class="main">
            <h1>StudioControl</h1>
            <button v-on:click="startPresentation" class="startPresentationButton">Präsentationsmonitor verbinden</button>
            <div><a ref="obsControlLink" target="_blank" href="" @click="obsControlLinkClick">OBS-Control zur Nutzung über eine unsichere Verbindung öffnen</a></div>
            <div class="disclaimer">
                This software product is "work in progress" and is provided by the provider "as is".<br />
                The provider makes no representations or warranties of any kind concerning the safety, suitability, lack of viruses, inaccuracies, typographical errors, or other harmful components of this software product. There are inherent dangers in the use of any software, and you are solely responsible for determining whether this software product is compatible with your equipment and other software installed on your equipment. You are also solely responsible for the protection of your equipment and backup of your data, and the provider will not be liable for any damages you may suffer in connection with using, modifying, or distributing this software product.
                Especially no liability is assumed for damages or data loss due to the use of this product.<br />
                The service may be changed, moved or stopped at any time without further notice.<br />
                <br />
                You are free to use this software. Redistribution, modification, decompilation or any other means of reverse engineering are prohibited.<br />
                ©2021 by Torsten Zühlke, all rights reserved.<br />
            </div>
            <div class="privacy">
                Privacy<br />
                For safety reasons we or our provider store every website access in logfiles. Those logfiles contain information about the visited websites like its address, the time and date of retrieval, diagnostic information like the content size and errorcodes, your IP address and hostname and information about your browser and operating system.<br />
                IP addresses and hostnames are anonymized at least after one week.
            </div>
        </div>
        <OBSControl class="right"></OBSControl>
        <!--<iframe sandbox="allow-scripts allow-forms allow-same-origin" class="right" ref="obsControlFrame">Parts of this application are not supported by your browser...</iframe>-->
        <PdfPreview ref="pdfPreview" class="bottom" @load-presentation="fileLoad" @set-presentation-and-page="setPresentationAndPage" :emitEvents="connectionAvailable"></PdfPreview>
    </div>
</template>

<script>
    import PdfPreview from './PdfPreview.vue';
    import OBSControl from './OBSControl.vue';

    export default {
        name: 'Home',
        props: {
        },
        data: function () {
            return {
                presentationRequest: undefined,
                presentationConnection: undefined,
                connectionAvailable: false,
            };
        },
        components: {
            PdfPreview,
            OBSControl,
        },
        mounted: function () {
            this.presentationRequest = new PresentationRequest([this.$router.resolve('receiver')['href']]);
            navigator.presentation.defaultRequest = this.presentationRequest;
            this.presentationRequest.addEventListener('connectionavailable', this.connectionOnAvailable);
            let x = this.$router.resolve({ name: 'obsControl', params: { url: process.env.BASE_URL + 'WS-Proxy/' }, query: { insecure: null } });
            let url = ((document.location.href.replace(/\/#.*$/, '') + '/' + (x.href.substring(0, 1) === '#' ? '?insecure' : '') + x.href).replace(/^https:\/\//i, 'http://').replace(/([^:])\/\//gi, '$1/'));
            this.$refs.obsControlLink.href = url;
            //this.$refs.obsControlFrame.src = url;
            //var self = this;
            //this.$refs.pdfPreview.addEventListener('fileLoad', function (event) {
            //    self.presentationConnection.send(JSON.stringify({ command: 'loadFile', type: event.data.type, id: event.data.id, }));
            //    self.presentationConnection.send(event.data.file);
            //});
            //this.$refs.pdfPreview.addEventListener('setPage', function (event) {
            //    self.presentationConnection.send(JSON.stringify({ command: 'setPage', page: event.data }));
            //});
        },
        methods: {
            obsControlLinkClick: function () {
                this.$refs.home.classList.add('noObsControl');
            },
            fileLoad: function (id, type, file) {
                if (this.presentationConnection) {
                    this.presentationConnection.send(JSON.stringify({ command: 'loadFile', type: type, id: id, }));
                    this.presentationConnection.send(file);
                }
            },
            setPresentationAndPage: function (presentation, page) {
                if (this.presentationConnection) {
                    this.presentationConnection.send(JSON.stringify({ command: 'setPresentationAndPage', presentation: presentation, page: page }));
                }
            },
            startPresentation: function () {
                console.log('Starting presentation request...');
                this.presentationRequest.start()
                    .then(connection => {
                        console.log('> Connected to ' + connection.url + ', id: ' + connection.id);
                    })
                    .catch(error => {
                        console.log('> ' + error.name + ': ' + error.message);
                    });
            },
            connectionOnAvailable: function (event) {
                if (this.presentationConnection && (this.presentationConnection.id != event.connection.id)) {
                    this.presentationConnection.terminate();
                }
                this.presentationConnection = event.connection;
                this.connectionAvailable = false;
                this.presentationConnection.addEventListener('close', this.connectionOnClose);
                this.presentationConnection.addEventListener('terminate', this.connectionOnTerminate);
                this.presentationConnection.addEventListener('message', this.connectionOnMessage);
                this.presentationConnection.addEventListener('connect', this.connectionOnConnect);
            },
            connectionOnClose: function () {
                //this.presentationConnection.reconnect() Muss auf einem Request ausgeführt werden...
                this.connectionAvailable = false;
                console.log('> Connection closed.');
            },
            connectionOnTerminate: function () {
                this.presentationConnection = undefined;
                this.connectionAvailable = false;
                console.log('> Connection terminated.');
            },
            connectionOnMessage: function (event) {
                console.log('> ' + event.data);
            },
            connectionOnConnect: function (event) {
                console.log('> ' + JSON.stringify(event));
                this.connectionAvailable = true;
                //setTimeout(function (self) {
//                    self.presentationConnection.send(JSON.stringify({ message: 1 }));
                //}(this), 500);
            },
        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .home:not(.noObsControl) {
        display: grid;
        grid-template-columns: 0 auto 300px 0;
        grid-template-rows: 0 auto 250px 0;
        grid-template-areas: ". . . . " ". main right ." ". bottom right ." ". . . .";
        height: 100vh;
        width: 100vw;
        gap: 8px;
    }

        .home.noObsControl {
            grid-template-columns: 0 auto 0;
            grid-template-areas: ". . . " ". main ." ". bottom ." ". . .";
        }

    .main {
        grid-area: main;
        overflow-y: auto;
        overflow-x: hidden;
    }

    .bottom {
        grid-area: bottom;
    }

    .home:not(.noObsControl) .right {
        grid-area: right;
        height: 100%;
    }

    .home.noObsControl .right {
        display: none;
    }

    iframe.right {
        border: none;
    }

    .startPresentationButton {
        font-size: 2rem;
    }

    .disclaimer,
    .privacy {
        color: grey;
        font-size: .9em;
        margin-top: 2rem;
    }

    .home ::-webkit-scrollbar {
        width: 0.5rem;
        height: 0.5rem;
    }

    .home ::-webkit-scrollbar-track {
        box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
        border-radius: 0.25rem;
    }

    .home ::-webkit-scrollbar-thumb {
        box-shadow: 0 0 6px rgba(0, 0, 0, 0.3);
        background-color: darkgrey;
        outline: none;
        border: none;
        border-radius: 0.25rem;
    }
</style>

